import { Box, BoxProps, ColorOptions, email, Form, ModalTypes, required, Spacer, Text } from '@jfs/ui-new'
import { mobileNumber } from '@jfs/utils'
import { Linking } from 'react-native'
import * as Yup from 'yup'
import { ButtonP } from '../../../comps/Button'
import { ContentDropdown } from '../../../comps/DropdownNew'
import { FloatingTextInput } from '../../../comps/FloatingTextInput'
import { staticStrings } from '../../../static/staticStrings'
import { colors } from '../../../util/colors'
import { useWindowDimensions } from '../../../util/util'
import { consumerEmail, consumerEmailSubject } from './EmailConstants'
import { emailDataFormatter } from './EmailDataParser'

const websiteValidation = Yup.string().matches(
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,
  'Please enter a valid input',
)
export const formData = (): any => [
  {
    formItems: [
      {
        fieldName: 'companyName',
        ComponentName: FloatingTextInput,
        editable: true,
        label: 'Company Name',
        validationSchema: required,
      },

      {
        fieldName: 'website',
        ComponentName: FloatingTextInput,
        editable: true,
        label: 'Website',
        validationSchema: websiteValidation,
      },

      {
        fieldName: 'businessType',
        ComponentName: ContentDropdown,
        type: 'Material',
        modalPosition: ModalTypes.CenteredWrap,
        editable: true,
        data: [
          { value: 'Web development', id: 0 },
          { value: 'IT', id: 1 },
          { value: 'Digital Marketing', id: 2 },
          { value: 'Freelancing', id: 3 },
          { value: 'Education', id: 4 },
          { value: 'Temple', id: 5 },
          { value: 'Others', id: 6 },
        ],
        placeHolder: 'Select Business Type',
        label: 'Type of Business',
        validationSchema: required,
      },
      {
        fieldName: 'spacer',
        ComponentName: Spacer,
        size: 0,
      },
      {
        fieldName: 'name',
        ComponentName: FloatingTextInput,
        editable: true,
        label: 'Contact person name',
        validationSchema: required,
      },

      {
        fieldName: 'mobile',
        ComponentName: FloatingTextInput,
        editable: true,
        label: 'Contact Number',
        maxLength: 10,
        validationSchema: mobileNumber,
      },

      {
        fieldName: 'workEmail',
        ComponentName: FloatingTextInput,
        editable: true,
        label: 'Email Address',
        validationSchema: email,
      },

      {
        fieldName: 'sp7',
        ComponentName: Spacer,
        size: 1,
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]

const sendCustomEmailWithBody = (receiverEmailId: string, subject: string, description: string) => {
  Linking.openURL(`mailto:${receiverEmailId}?subject=${subject}&body=${description}`)
}

const ContactForm = () => {
  const viewPortWidth = useWindowDimensions()
  const isMobile = viewPortWidth < 600

  const styles = style()
  const renderActionButtons = ({ isValid, values }: any) => {
    const handleVerify = () => {
      console.log(values)
      const emailData = emailDataFormatter(values)
      sendCustomEmailWithBody(consumerEmail, consumerEmailSubject, emailData)
    }

    const handlePrivacy = () => {
      Linking.openURL(staticStrings.privacyPolicyLink)
    }

    return (
      <>
        <ButtonP
          isFull
          color={colors.HIGHLIGHT as ColorOptions}
          disabled={!isValid}
          onPress={handleVerify}
          title={'Contact JioPay'}
        />
        <Spacer size="MEDIUM" />
        <Text fontSize={12} textAlign="center" lineHeight={16} fontFamily="jiotype-medium" color="SECONDARY_GREY">
          By completing this form, I have read and acknowledged the
          <Box onPress={handlePrivacy} underlayColor={'TRANSPARENT'}>
            <Text
              fontSize={12}
              textDecorationLine="underline"
              fontFamily="jiotype-medium"
              color="SECONDARY_GREY"
              nativeID={'becomePartnerForm'}>
              {' Privacy Policy '}
            </Text>
          </Box>
          and agree that JioPay may contact me at the email address or phone number above
        </Text>
      </>
    )
  }

  return (
    <Box {...styles.container(isMobile)}>
      <Form
        container={({ children }) => <Box {...styles.formBox}>{children}</Box>}
        formData={formData()}
        actionButtons={renderActionButtons}
        initialValues={{}}
      />
    </Box>
  )
}

const style = () => {
  return {
    container: (isMobile: boolean) =>
      ({
        backgroundColor: 'WHITE',
        paddingHorizontal: isMobile ? 24 : 42,
        paddingVertical: isMobile ? 36 : 42,
        borderRadius: isMobile ? 16 : 24,
        maxWidth: 420,
        shadowColor: '#000' as ColorOptions,
        shadowOffset: {
          width: 0,
          height: 5,
        },
        shadowOpacity: 0.16,
        shadowRadius: 16,
        overflow: 'hidden',
        position: 'relative',
        top: 0,
        zIndex: 999,
        marginTop: isMobile ? -16 : 20,
        // width: isMobile ? 312 : 408,
      } as BoxProps),
    formBox: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      zIndex: 999,
      overflow: 'visible',
    } as BoxProps,
  }
}

export default ContactForm
